/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { PostUploadLogoMutationRequest, PostUploadLogoMutationResponse, PostUploadLogoQueryParams, PostUploadLogo400 } from "../../models/PostUploadLogo";
import type { RequestConfig, ResponseErrorConfig } from "@/client";
import { buildFormData } from "../../.kubb/config";

function getPostUploadLogoUrl() {
  const res = { method: 'POST', url: `/api/v1/logos` as const }  
  return res
}

/**
 * {@link /api/v1/logos}
 */
export async function postUploadLogo({ data, params }: { data: PostUploadLogoMutationRequest; params?: PostUploadLogoQueryParams }, config: Partial<RequestConfig<PostUploadLogoMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  const formData = buildFormData(requestData)  
  const res = await request<PostUploadLogoMutationResponse, ResponseErrorConfig<PostUploadLogo400>, PostUploadLogoMutationRequest>({ method : "POST", url : getPostUploadLogoUrl().url.toString(), params, data : formData as FormData, ... requestConfig })  
  return res.data
}